/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Pergi_GInputs */

const en_tut_pergi_g = /** @type {(inputs: Tut_Pergi_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming back from a long meeting or from leave usually means scrolling backwards. This briefing replaces that work.`)
};

const id_tut_pergi_g = /** @type {(inputs: Tut_Pergi_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali setelah rapat panjang atau cuti biasanya berarti menggulir ke belakang. Ringkasan ini menggantikan pekerjaan itu.`)
};

/**
* | output |
* | --- |
* | "Coming back from a long meeting or from leave usually means scrolling backwards. This briefing replaces that work." |
*
* @param {Tut_Pergi_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_pergi_g = /** @type {((inputs?: Tut_Pergi_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Pergi_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_pergi_g(inputs)
	return en_tut_pergi_g(inputs)
});